<style>
  tr:hover td {
      background-color: #3F51B5;
  }
    .unsubscribedColor {color: #E91E63 !important;}
    .problemColor {color: #e9d81e !important;}
    .subscribedColor {color: #0f9e3e !important;}

</style>
<template>
  <div>
	<h1 class="page-header mb-3">Registration Admin</h1>
  <div class="row">
      <div class="col-xl-12">
        <div class="card border-0 mb-3 overflow-hidden bg-gray-800 text-white">
          <div class="card-body">
            <p>Use this form to generate passcodes for the desktop applications.</p>
            <div class="col-md-4">
              <input class="form-control mb-5px" v-model="edit1" type="text" placeholder="Input code here...">
            </div>
            <div class="col-md-4">
              <input  class="form-control mb-5px" v-model="edit2" type="text" placeholder="Generated Passcode" readonly>
            </div>

            <b-button variant="primary" @click="button1Click">Autofill</b-button>&nbsp;
            <b-button variant="primary" @click="button2Click">Convert & Copy</b-button>&nbsp;
            <b-button @click="button4Click">Clear</b-button>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import moment from 'moment';
//import AppOptions from '../config/AppOptions.vue';
import { useCookies } from "vue3-cookies";


export default {
  name: 'registrationdash',
    setup() {
      const { cookies } = useCookies();
      return { cookies };
    },
    data() {
      return {
        edit1: '',
        edit2: '',
      }
    },
    methods: {
        button1Click() {
        let s = '';
        for (let i = 0; i < 7; i++) {
          s += String.fromCharCode(97 + Math.floor(Math.random() * 26)); // a-z
          s += String.fromCharCode(48 + Math.floor(Math.random() * 10)); // 0-9
          s += String.fromCharCode(65 + Math.floor(Math.random() * 26)); // A-Z
        }
        s += String.fromCharCode(48 + Math.floor(Math.random() * 10)); // 0-9
        this.edit1 = s;
      },
      button2Click() {
        // Assuming `edit1` and `edit2` are the model properties bound to your Vue.js component's template
        /*
        let S = this.edit1; // Equivalent to S := Edit1.Text;
        let N = parseInt(S.slice(-1), 10); // Equivalent to N := StrToInt(Copy(S,Length(S),1));
        S = S.substring(N - 1, N - 1 + 10); // Adjusted for zero-based indexing

        // Initialize S2 to an empty string
        let S2 = '';
        for (let I = 1; I <= 10; I++) {
            S2 += this.getCharNum(S.substring(I - 1, I)); // Adjusted for zero-based indexing
        }

        // If S2 is shorter than 10 characters, pad it with its own last generated character
        if (S2.length < 10) {
            const lastGeneratedDigit = S2.slice(-1); // Get the last generated character of S2
            S2 = S2.padEnd(10, lastGeneratedDigit);
        }

        this.edit2 = S2; // Set the padded S2 as the value of edit2
        */

        let S = this.edit1;
        let lastChar = S.slice(-1);
        let N = parseInt(lastChar);
        let startIndex = N - 1;
        if (N === 0 || N === 1) {
            startIndex = 0;
        }
        S = S.substring(startIndex, startIndex + 10);
        //this.edit2 = S.slice(-1);
        this.edit2 = S;
        //l6Ks0Es4Dn0Uw5Jk4Wc7P9
        //v5Wm0Rn0Qp6Qg2Uu7Gg2P9
        let S2 = '';
        let lastCryptChar = '';
        for (let i = 0; i < 10; i++)
        {
            let cryptChar = this.getCharNum(S.charAt(i));
            if (cryptChar === '!')
            {
              cryptChar = lastCryptChar;
            }
            S2 += '' + cryptChar;
            lastCryptChar = cryptChar;
        }
        this.edit2 = S2;
      },
      getCharNum(s)
      {
        switch (s)
        {
          case 'a': return '9';
          case 'b': return '8';
          case 'c': return '7';
          case 'd': return '6';
          case 'e': return '5';
          case 'f': return '4';
          case 'g': return '3';
          case 'h': return '2';
          case 'i': return '1';
          case 'j': return '1';
          case 'k': return '9';
          case 'l': return '8';
          case 'm': return '7';
          case 'n': return '6';
          case 'o': return '5';
          case 'p': return '4';
          case 'q': return '3';
          case 'r': return '2';
          case 's': return '1';
          case 't': return '9';
          case 'u': return '8';
          case 'v': return '7';
          case 'w': return '6';
          case 'x': return '5';
          case 'y': return '4';
          case 'z': return '3';
          case '0': return '2';
          case '1': return '1';
          case '2': return '9';
          case '3': return '8';
          case '4': return '7';
          case '5': return '6';
          case '6': return '5';
          case '7': return '4';
          case '8': return '3';
          case '9': return '2';
          default: return '!';
        }
      },
      button4Click() {
        this.edit1 = '';
        this.edit2 = '';
        // There's no direct equivalent to SetFocus in Vue.js, but you can use
        // this.$refs.inputRef.focus() if you assign a ref="inputRef" to the input element.
      },
      copyTextToClipboard(text) {
        navigator.clipboard.writeText(text).then(function() {
          console.log('Copying to clipboard was successful!');
        }, function(err) {
          console.error('Could not copy text: ', err);
        });
      }
    },
    created() {

    },
    mounted: function()
    {

    }
	}
</script>